module.exports = __webpack_public_path__ + "img/payment_plan_2.bacfd831.png";